import styled from "styled-components";
import { CARD_STYLED_PROPS } from "../interface";
// Custom Game rules styles

export const Title = styled.h2`
  font-size: 18px;
  margin-top: 8px;
  text-transform: capitalize;
  line-height: 1.8;
`;
export const CardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
`;
export const Card = styled.div<CARD_STYLED_PROPS>`
  background: ${({ background, isWin }) => (isWin ? "#ffb000" : background)};
  border-radius: 9px;
  height: 76px;
  width: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    font-size: 24px;
    font-family: "GT America, boldN";
    color: ${({ colors }) => colors};
    line-height: 1;
  }
  svg {
    width: 26px;
    height: 20px;
    path {
      fill: ${({ colors }) => colors};
    }
  }
`;
